import { atom } from 'recoil';
import { IAnimation } from '../../../game-server/src/modules/client/ClientManager';

export interface IAnimationWithTime extends IAnimation {
	startTime: number;
}

export const animationAtom = atom({ key: 'animationAtom', default: undefined as IAnimationWithTime | undefined });
